import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import {
  Button,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import styles from './styles.module.css';
import api from '../../core/api';
import UsersCouponTable from '../../components/UsersCouponTable';
import Coupons from '../../models/Coupons';
import {GetData} from '../../utils/Storage';
import {useQueryParams} from '../../hooks/useQueryParams';

const UsersCouponsPage = ({history}) => {
  const [allUsersCoupons, setAllUsersCoupons] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [isLoading, setLoading] = useState(true);
  const [selectCoupon, setSelectCoupon] = useState('');
  const [getCoupons, setCoupons] = useState([]);
  const [statusFilter, setStatusFilter] = useState(null);
  const [error, setError] = useState(false);
  const user = GetData('business');
  const params = useQueryParams();

  const fetchCoupon = async () => {
    try {
      const allCoupons = await Coupons.findAll();
      setCoupons(allCoupons);
    } catch (e) {
      // console.log({e});
    }
  };

  useEffect(() => {
    fetchCoupon();
  }, []);

  useEffect(() => {
    if (params?.cupom) {
      setSelectCoupon(params?.cupom);
    }
  }, [getCoupons]);

  async function fetchCoupons() {
    setLoading(true);
    const filters = {
      couponId: selectCoupon,
      status: statusFilter,
    };

    try {
      const {data} = await api.get('users_coupon', {params: {filters}});
      setAllUsersCoupons(data);
      setError(false);
    } catch (err) {
      setError(true);
    } finally {
      setFirstLoading(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchCoupons();
  }, [statusFilter, selectCoupon]);

  if (error) {
    return (
      <div>
        <p style={{textAlign: 'center'}}>Ocorreu um erro ao obter os dados.</p>
        <p style={{textAlign: 'center'}}>
          <a href="javascript:void(0)" onClick={fetchCoupons}>
            Tentar novamente
          </a>
        </p>
      </div>
    );
  }

  return (
    <Dashboard>
      {firstLoading ? (
        <div className="flex-col center-a center-b" style={{height: '50vh'}}>
          <span style={{paddingTop: '10em'}}>
            <CircularProgress size={100} />
            <p> Carregando... </p>
          </span>
        </div>
      ) : (
        <div style={{overflow: 'hidden'}}>
          <div className={styles['filter-bar']}>
            <FormControl style={{width: '20%'}}>
              <InputLabel>Selecione o cupom</InputLabel>

              <Select
                variant="outlined"
                value={selectCoupon}
                label="Selecione a empresa"
                disabled={!user.adminMaster}
                onChange={e => setSelectCoupon(e.target.value)}>
                {getCoupons && [
                  <MenuItem value={null}>Todos</MenuItem>,
                  ...getCoupons.map(e => {
                    return <MenuItem value={e.id}>{e.couponCode}</MenuItem>;
                  }),
                ]}
              </Select>
            </FormControl>

            <FormControl style={{width: '20%'}}>
              <InputLabel
                id="subscription-type-label"
                style={{paddingLeft: '15px'}}>
                Status
              </InputLabel>
              <Select
                labelId="subscription-type-label"
                className={styles.select}
                variant="outlined"
                placeholder=""
                defaultValue={null}
                value={statusFilter}
                onChange={event => setStatusFilter(event.target.value)}>
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="active">Ativo</MenuItem>
                <MenuItem value="inactive">Inativo</MenuItem>
                <MenuItem value="expired">Expirado</MenuItem>
                <MenuItem value="cancelled">Cancelado</MenuItem>
                <MenuItem value="pending">Pendente</MenuItem>
              </Select>
            </FormControl>
          </div>
          {isLoading ? (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em'}}>
                <CircularProgress size={100} />
                <p> Carregando... </p>
              </span>
            </div>
          ) : allUsersCoupons.length <= 0 ? (
            <div
              style={{
                display: 'flex',
                marginBottom: '10px',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <p
                style={{
                  fontSize: '1.1876rem',
                  color: '#b1a4aa',
                }}>
                Nenhum usuário encontrado.
              </p>
            </div>
          ) : (
            <div style={{marginTop: '2rem'}}>
              <UsersCouponTable usersCoupon={allUsersCoupons} />
            </div>
          )}
        </div>
      )}
    </Dashboard>
  );
};

export default UsersCouponsPage;
